'use strict';

import Path from 'path';
import ajv from 'ajv';
import pluginError from 'plugin-error';
import through2 from 'through2';
import * as util from '../utilities';

const PLUGIN_NAME = 'gulp-manifest-validator';

function gulpManifestValidator() {
    return through2.obj(
        function (file, encoding, callback) {
            let manifest;
            // first make sure the file is json.
            try {
                manifest = JSON.parse(file.contents.toString());
            } catch (e) {
                const error = (!e.plugin || (e.plugin !== PLUGIN_NAME)) ?
                    util.extendError(new pluginError({ plugin: PLUGIN_NAME, message: e.message }), e) : e;
                callback(error);
                return;
            }

            // next try to resolve the schema
            let schemaPath = manifest.$schema;
            if (!schemaPath || typeof schemaPath !== 'string') {
                callback(new pluginError({ plugin: PLUGIN_NAME, message: `Invalid $schema property in manifest: ${file.path}` }));
                return;
            }
            // resolve the absolute path to the schema from the file path and the schemaPath
            schemaPath = Path.resolve(file.base, schemaPath);
            if (schemaPath.endsWith('.json#')) {
                schemaPath = schemaPath.substring(0, schemaPath.length - 1);
            }

            // fetch the schema
            const schema = require(schemaPath);

            // use the schema to validate the manifest
            const validator = new ajv({ allErrors: true, verbose: true });
            const validate = validator.compile(schema);
            const valid = validate(manifest);
            if (!valid) {
                let message = 'Invalid manifest';
                if (validate.errors && validate.errors.length > 0) {
                    message = `${validate.errors.length} problems found.\n\n`;
                    validate.errors.forEach(e => {
                        message += `location: ${e.dataPath}.${e.propertyName || ''}\n`;
                        // message += `data: ${JSON.stringify(e.data)}\n`;
                        message += `error: ${e.message}\n`;
                        if (e.params) {
                            const keys = Object.keys(e.params);
                            keys.forEach(key => {
                                message += `${key}: ${JSON.stringify(e.params[key])}`;
                            });
                        }

                        message += '\n\n';

                    });
                }
                callback(new pluginError({ plugin: PLUGIN_NAME, message: `Invalid manifest:\n${message}` }));
                return;
            }

            callback();
        });
}

module.exports = gulpManifestValidator;
